export function getTableFilterInstanceId(
  widgetFilterInstanceId: string,
  pageFilterInstanceId: string
): string {
  return `${widgetFilterInstanceId}-${pageFilterInstanceId}`;
}

/**
 * Table-filter store keys are `${widgetFilterInstanceId}-${pageFilterInstanceId}`.
 * Do not match the bare widget/page key: on dashboard tiles those ids are equal,
 * and resetting custom table filters must not wipe the tile's page-filter selections.
 */
export function isWidgetTableFilterStoreKey(
  storeKey: string,
  widgetFilterInstanceId: string
): boolean {
  return storeKey.startsWith(`${widgetFilterInstanceId}-`);
}
